<template>
  <div class="page_content" v-if="permission && permission.version === '5'">

    <div class="row page-heading mx-0">
      <div class="col-8 input module_heading" role="heading" aria-level="1">
        <span class="module_icon icon-link"></span>
        <span class="module_type_name">Quick Link Management</span>
      </div>
      <div class="col-4 submit btn-container text-right">
        <button type="button" class="btn btn-primary" @click.prevent="create" aria-label="create" :disabled="permission.systemPermission.readOnly">create</button>
      </div>
    </div>
    <div class="folder-management-section quick-link-list-section" v-if="isDataSetupFromServer">
      <div class="page_subheading">
        <div class="toolbar-right ui-list-toolbar">
          <select v-model="perPage" aria-label="page size" class="page_size">
            <option v-for="option in pageOptions" v-bind:value="option">
              {{ option }}
            </option>
          </select>
          <div class="btn_container pagination_sty3">
            <b-pagination
              align="center"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              :limit="1"
              :hide-goto-end-buttons="true"
              :label-prev="$t('previousPage')"
              :label-next="$t('nextPage')">
              <template #prev-text>
                <span class="ic2_arr_pre3" aria-hidden="true"></span>
              </template>
              <template #next-text>
                <span class="ic2_arr_next3" aria-hidden="true"></span>
              </template>
            </b-pagination>
          </div>
          <div class="search-box-container">
            <input type="text" class="input-search" v-model="filter" placeholder="search by quick link title" aria-label="search by quick link title">
            <button type="button" class="btn btn_srh" aria-label="search quick links">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>
      <b-container fluid>
        <b-row class="quick-link-list-table">
          <b-table bordered :isRowHeader="true" :head-variant="'light'" :items="items"  :fields="fields"
            :current-page="currentPage" :per-page="perPage" :filter="filter" @filtered="onFiltered" class="quick-link-management-table">
            <template slot="title" slot-scope="row">
              {{row.value}}
            </template>
            <template slot="url" slot-scope="row">
              {{row.value}}
            </template>
            <template slot="actions" slot-scope="row">
              <template v-if="permission.systemPermission.readOnly">
                <span class="action-link icon-pencil mr-2" aria-label="edit" tabindex="0" style="pointer-events: none; color: #ccc;"></span>
                <span class="action-link icon-bin" aria-label="delete" tabindex="0" style="pointer-events: none; color: #ccc;"></span>
              </template>
              <template v-else>
                <b-btn class="action-link btn_ic icon-pencil mr-2" @click="editQuickLink(row.item)" :aria-label="$tf('edit', 'edit')" :title="$tf('edit', 'edit')" v-b-tooltip.hover tabindex="0"></b-btn>
                <b-btn class="action-link btn_ic icon-bin" @click="showDeleteQuickLinkConfirmBox(row.item)" :aria-label="$tf('delete', 'delete')" :title="$tf('delete', 'delete')" v-b-tooltip.hover tabindex="0"></b-btn>
              </template>
            </template>
          </b-table>
          <template v-if="shouldShowNoResultFound">
            <span class="no-result">No Results Found</span>
          </template>
        </b-row>
      </b-container>
    </div>
    <div>
      <b-modal class="delete-folder-popup" ref="deleteQuickLinkModal" :title="'Please Confirm!'"  ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div>
          <span>{{ quicklinkDeleteMessage }}</span>
        </div>
        <div slot="modal-header" class="popover-header">
          <div class="popup-heading">Please Confirm!</div>
          <button class="btn_close" aria-label="close" @click="hideDeleteConfirmBox">
          <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteQuickLinkAndHideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
          <b-button @click="hideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
  import '../../../assets/module/css/quickLinksManagement/quickLinksList.min.css'
  import { mapActions, mapState } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'quickLinkList',
    data () {
      return {
        items: [],
        fields: [
          {key: 'title', label: 'Quick Link Title', class: 'first-column'},
          {key: 'url', label: 'Url', class: 'second-column'},
          {key: 'type', label: 'Type', class: 'third-column'},
          {key: 'actions', label: 'Actions', class: 'fourth-column text-center'}
        ],
        totalRows: 0,
        quickLinkToDelete: '',
        quicklinkDeleteMessage: '',
        isDataSetupFromServer: false,
        currentPage: 1,
        perPage: 10,
        pageOptions: [ 10, 50, 100 ],
        filter: '',
        shouldShowNoResultFound: false
      }
    },

    mounted () {
      this.loadPermission().then(res => {
        this.$refs.loadingModal.show()
        setTimeout(() => {
          this.loadQuickLinksForInstitution()
        }, 250)
      })
    },

    methods: {
      ...mapActions([
        'deleteSeletedQuickLink',
        'loadAllQuickLinksForInstitution',
        'loadPermission'
      ]),

      loadQuickLinksForInstitution () {
        this.loadAllQuickLinksForInstitution().then(res => {
          this.items = _.orderBy(res, ['lastUpdatedTime'], ['desc'])
          this.totalRows = this.items.length
          this.isDataSetupFromServer = true
          this.$refs.loadingModal.hide()
        })
      },

      create () {
        let length = (this.totalRows > 0) ? (this.totalRows + 1) : 1
        return this.$router.push({name: 'quickLinkCreate', params: {order: length, maxOrder: length}})
      },

      editQuickLink (quickLink) {
        return this.$router.push({name: 'quickLinkEdit', params: {uuid: quickLink.uuid, title: quickLink.title, uri: quickLink.url, icon: quickLink.icon,type: quickLink.type, order: quickLink.order, maxOrder: (this.totalRows + 1)}})
      },

      showDeleteQuickLinkConfirmBox (quickLink) {
        this.quickLinkToDelete = quickLink
        this.quicklinkDeleteMessage = 'Are you sure you want delete "' + quickLink.title + '" quick link.'
        this.$refs.deleteQuickLinkModal.show()
      },

      hideDeleteConfirmBox () {
        this.$refs.deleteQuickLinkModal.hide()
      },

      deleteQuickLinkAndHideDeleteConfirmBox () {
        this.hideDeleteConfirmBox()
        this.$refs.loadingModal.show()
        let uuids = [this.quickLinkToDelete.uuid]
        this.deleteSeletedQuickLink(uuids).then(res => {
          setTimeout(() => {
            this.loadQuickLinksForInstitution()
            this.$refs.loadingModal.hide()
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Quick Link "' + this.quickLinkToDelete.title + '" deleted successfully.'
            })
          }, 1000)
        })
      },

      onFiltered (filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
        if (filteredItems.length === 0) {
          this.shouldShowNoResultFound = true
        } else {
          this.shouldShowNoResultFound = false
        }
      }
    },
    computed: {
      ...mapState({
        'permission': state => state.user.permission
      })
    }
  }
</script>

<style scoped>
    .action-link {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/app/quickLink/components/QuickLinkList.vue